import { all } from 'redux-saga/effects';
import bookingSaga from './booking';
import themeSaga from './theme';
import paymentSaga from "./paymentGateway/paymentBeam";
import hotelProfilesaga from "./hotelProfile";
import authSaga from './auth';
import rootAdminSaga from './admin';

export default function* rootSaga() {
  yield all([
    bookingSaga(),
    themeSaga(),
    paymentSaga(),
    hotelProfilesaga(),
    authSaga(),
    rootAdminSaga()
  ]);
}
